var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.activity && !!_vm.selectedPack)?_c('div',{staticClass:"preset-wrap"},[_c('suggested-game',{attrs:{"game":_vm.activity,"preset":_vm.selectedPack},on:{"close-modal":_vm.closeSuggestedGameModal}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }